import http from './request'

// 判断是否绑定tg uerid
export const getTgUserInfo = (data) => {
  return http({
    url: '/user/TelegramUser/getInfo',
    method: 'post',
    data
  })
}

// 检查 用户是否绑定 指定类型机器人
export const checkBindRobot = (data) => {
  return http({
    url: '/user/TelegramUser/checkBind',
    method: 'post',
    data
  })
}

// 获奖装填
export const queryLotteryStatus = (data) => {
  return http({
    url: '/promotion/CoinLottery/queryLotteryStatus',
    method: 'post',
    data
  })
}

// 邀请记录列表
export const getInviteRecord = (data) => {
  return http({
    url: '/promotion/CoinUserBind/getLuckyDrawInvitePagedList',
    method: 'post',
    data
  })
}

// 获取加载图片背景
export const getBgConfigUrl = (data) => {
  return http({
    url: '/user/TelegramUser/getConfig',
    method: 'post',
    data
  })
}

export const getParamToken = (data) => {
  return http({
    url: '/bizBase/ShareLink/getParamToken',
    method: 'post',
    data
  })
}
//获取 CoinLuckyDraw 配置信息
export const getCoinLuckyDrawConfig = (data) => {
  return http({
    url: '/promotion/LuckyDraw/getConfig',
    method: 'post',
    data
  })
}

// 获取任务列表
export const getLuckyDrawTaskList = (data) => {
  return http({
    url: '/promotion/LuckyDraw/listTask',
    method: 'post',
    data
  })
}

// 领取任务
export const luckyDrawAcceptTask = (data) => {
  return http({
    url: '/promotion/LuckyDraw/acceptTask',
    method: 'post',
    data
  })
}

// spin模块的提现轮播
export const getSpinWithdrawList = (data) => {
  return http({
    url: '/promotion/LuckyDraw/getWithdrawList',
    method: 'post',
    data
  })
}

// spin新用户邀请下级列表
export const getSpinNewUserInviteList = (data) => {
  return http({
    url: '/promotion/LuckyDraw/getInvitePagedList',
    method: 'post',
    data
  })
}

// 领取任务奖励
export const receiveLuckyDrawReward = (data) => {
  return http({
    url: '/promotion/LuckyDraw/receiveReward',
    method: 'POST',
    data
  })
}

// 获取提现提示信息
export const getWithdrawViewInfo = (data) => {
  return http({
    url: '/promotion/LuckyDraw/getWithdrawViewInfo',
    method: 'POST',
    data
  })
}
